import React from 'react';
import { useIntl } from 'react-intl';
import { TablePagination } from '@material-ui/core';
import { rowsPerPage } from '../utils/TableStyles';

/**
 * Paginación de las grillas de React/MUI.
 *
 * Envuelve el `TablePagination` que está copiado en 35 grillas con las mismas 11 líneas, y
 * de paso resuelve dos cosas que hoy están mal:
 *
 *  - **Los textos estaban en español fijo.** 23 grillas escriben `labelRowsPerPage="Mostrar"`
 *    y el `labelDisplayedRows` con un template literal, en una app que también se usa en
 *    portugués. Acá salen del catálogo, con las keys que ya existen (`Mostrar` y
 *    `pagination.displayedRows`).
 *  - **Las opciones de tamaño eran seis listas distintas** ([5,10,25,50,100] en 17 grillas,
 *    la constante compartida en 9, [10,25,50,100] en 4, y otras tres variantes). El default
 *    es la constante compartida `rowsPerPage`; una grilla que necesite otra cosa la pasa.
 *
 *     <GridPagination count={total} page={pagination.page} perPage={pagination.perPage}
 *                     onPageChange={handleChangePage} onPerPageChange={handleChangeRowsPerPage} />
 *
 * Los nombres de las props de MUI cambiaron entre v4 y v5; se usan los nuevos
 * (`onPageChange` / `onRowsPerPageChange`), que 4.12 ya soporta.
 */
const GridPagination = (props) => {
	const intl = useIntl();

	return (
		<TablePagination
			rowsPerPageOptions={props.rowsPerPageOptions || rowsPerPage}
			component={props.component || 'div'}
			count={props.count}
			rowsPerPage={props.perPage}
			page={props.page}
			onPageChange={props.onPageChange}
			onRowsPerPageChange={props.onPerPageChange}
			labelRowsPerPage={intl.formatMessage({ id: 'Mostrar', defaultMessage: 'Mostrar' })}
			labelDisplayedRows={({ from, to, count }) =>
				intl.formatMessage(
					{ id: 'pagination.displayedRows', defaultMessage: 'Mostrando {from} a {to} de {count}' },
					{ from: from, to: to, count: count }
				)
			}
		/>
	);
};

export default GridPagination;
